import LoadingPage from './LoadingPage'
import useConfirmationActions from './useConfirmationActions'

const QuickCheckoutHandler = () => {
  const { goToMyRecording } = useConfirmationActions()

  if (goToMyRecording) {
    window.location.href = goToMyRecording
  }

  return <LoadingPage />
}

export default QuickCheckoutHandler
